export enum RateTypes{
    Unit = 1,
    Fixed = 2,
    Free = 3,
    Rush = 4
}